<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 18:13:05
 * @Description: 完善资料
-->
<template>
	<div class="perfect_info">
		<div class="container">
			<div class="title">{{ $t("login.perfect_info.title") }}</div>

			<div class="tips">
				<a-alert :message="$t('login.perfect_info.tip')" type="warning" show-icon />
			</div>

			<a-form-model :model="form" ref="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 15 }">
				<a-row :gutter="16"></a-row>
				<a-form-model-item
					:label="$t('base.mobile.label')"
					v-if="basicSetInfo.sjh != 3"
					prop="sjh"
					:rules="[
						{ required: basicSetInfo.sjh == 1 ? true : false, message: $t('base.mobile.placeholder') },
						{ pattern: /^1[3456789]\d{9}$/, message: $t('base.mobile.error_tip') },
					]"
				>
					<a-input v-model="form.sjh" :placeholder="$t('base.mobile.placeholder')" allowClear></a-input>
				</a-form-model-item>
				<!-- <a-form-model-item
					label="手机验证码"
					v-if="basicSetInfo.sjh != 3"
					prop="sjhCode"
					:rules="[{ required: basicSetInfo.sjh == 1 ? true : false, message: '请输入手机验证码' }]"
				>
					<a-input v-model="form.sjhCode" placeholder="请输入手机验证码" allowClear></a-input>
				</a-form-model-item> -->
				<a-form-model-item
					:label="$t('base.email.label')"
					v-if="basicSetInfo.yx != 3"
					prop="yx"
					:rules="[
						{ required: this.basicSetInfo.yx == 1 ? true : false, message: $t('base.email.placeholder') },
						{ pattern: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/, message: $t('base.email.error_tip') },
					]"
				>
					<a-input v-model="form.yx" :placeholder="$t('base.email.placeholder')" allowClear></a-input>
				</a-form-model-item>
				<!-- <a-form-model-item
					label="邮箱验证码"
					v-if="basicSetInfo.yx != 3"
					prop="yxCode"
					:rules="[{ required: this.basicSetInfo.yx == 1 ? true : false, message: '请输入邮箱验证码' }]"
				>
					<a-input v-model="form.yxCode" placeholder="请输入邮箱验证码" allowClear></a-input>
				</a-form-model-item> -->
				<a-form-model-item
					:label="$t('login.perfect_info.birth_label')"
					v-if="basicSetInfo.sr != 3"
					prop="sr"
					:rules="{ required: this.basicSetInfo.sr == 1 ? true : false, message: $t('login.perfect_info.birth_placeholder') }"
				>
					<a-date-picker v-model="form.sr" :placeholder="$t('login.perfect_info.birth_placeholder')" />
				</a-form-model-item>
				<template v-if="basicSetInfo.aqwt != 3">
					<template v-for="(item, index) in form.questionVos">
						<a-form-model-item
							:key="`qus${index}`"
							:label="`${$t('base.question.label')}${index + 1}`"
							:prop="'questionVos.' + index + '.question'"
							:rules="{ required: basicSetInfo.aqwt == 1 ? true : false, message: $t('base.question.question_placeholder') }"
						>
							<a-select v-model="item.question" :placeholder="$t('base.question.question_placeholder')" allowClear>
								<a-select-option v-for="qus in qusArr2" :value="qus.id" :key="qus.id" :disabled="qus.disabled">
									{{ qus.question }}
								</a-select-option>
							</a-select>
						</a-form-model-item>
						<a-form-model-item
							:key="`ans${index}`"
							:label="`${$t('base.question.answer')}${index + 1}`"
							:prop="'questionVos.' + index + '.answer'"
							:rules="{ required: basicSetInfo.aqwt == 1 ? true : false, message: $t('base.question.placeholder') }"
						>
							<a-input v-model="item.answer" :placeholder="$t('base.question.placeholder')" allowClear></a-input>
						</a-form-model-item>
					</template>
				</template>
			</a-form-model>

			<div class="footer">
				<a-button @click="goLogin">{{ $t("base.btn.back_login") }}</a-button>
				<a-button type="primary" @click="handleOk">{{ $t("base.btn.sure") }}</a-button>
			</div>
		</div>
	</div>
</template>

<script>
import { commonAPI } from "@/apis";
import { commonMethods } from "../mixins/common";

export default {
	name: "PerfectInfo",
	mixins: [commonMethods],
	data() {
		return {
			qusArr: [],
			form: {
				sjh: "",
				yx: "",
				sr: "",
				questionVos: [
					{ question: undefined, answer: "" },
					{ question: undefined, answer: "" },
					{ question: undefined, answer: "" },
				],
			},
			basicSetInfo: {},
			before_login: {},
		};
	},
	computed: {
		qusArr2() {
			let arr = this.qusArr;
			arr.forEach((el) => {
				let item = this.form.questionVos.find((o) => o.question == el.id);
				el.disabled = item ? true : false;
			});
			return arr;
		},
	},
	beforeRouteEnter(to, form, next) {
		next((vm) => {
			// 判断是否可进入该路由
			let before_login = JSON.parse(sessionStorage.getItem("BEFORE_LOGIN"));
			if (!before_login || !before_login.showInfo) {
				vm.$router.replace({ path: form.path });
			} else {
				vm.before_login = { ...before_login };
			}
		});
	},
	created() {
		// 获取登录配置
		let basicSetInfo = sessionStorage.getItem("BASIC_SET_INFO");
		this.basicSetInfo = basicSetInfo ? JSON.parse(basicSetInfo) : {};

		this.getDefaultInfo();
	},
	methods: {
		// 获取默认密保
		async getDefaultInfo() {
			const { code, data } = await commonAPI.getAction("/user/password/question/getAll");
			if (code == 0) {
				this.qusArr = data || [];
			}
		},
		handleOk() {
			this.$refs.form.validate((valid) => {
				if (valid) {
					let params = [];
					let obj = this.form;
					for (const key in obj) {
						if (key == "questionVos") {
							params.push({ filter: "aqwt", classify: this.basicSetInfo["aqwt"], questionVos: obj[key] });
						} else {
							params.push({ filter: key, val: obj[key], classify: this.basicSetInfo[key] });
						}
					}
					this.handleOkApi(params);
				} else {
					return false;
				}
			});
		},
		async handleOkApi(params) {
			const { code, message } = await commonAPI.postAction(`/users/update/${this.user.username}`, params);
			if (code == 0) {
				this.$message.success(message);
				this.before_login.showInfo = false;
				sessionStorage.setItem("BEFORE_LOGIN", JSON.stringify(this.before_login));
				this.jumpComputed();
			} else {
				this.$message.error(message);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.perfect_info::v-deep {
	width: 100%;
	height: 100%;
	padding-top: 35px;
	.container {
		max-width: 800px;
		width: 80%;
		margin: 0 auto;
		background-color: #fff;
		padding: 30px 0;
		border-radius: 20px;
		.title {
			font-size: 22px;
			text-align: center;
			margin-bottom: 20px;
		}

		.tips {
			padding: 0 35px;
			margin-bottom: 30px;
		}
	}

	.ant-calendar-picker {
		width: 100%;
	}

	.form_title {
		margin-bottom: 24px;
		text-align: right;
		font-size: 13px;
		font-weight: normal;
	}
	.footer {
		text-align: center;
		margin-top: 10px;
		.ant-btn + .ant-btn {
			margin-left: 40px;
		}
	}
}
</style>
